import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Estimates from '../views/Estimates.vue';
import Estimate from '../views/Estimate.vue';
import Booking from '../views/Booking.vue';
import Customers from '../views/Customers.vue';
import Parts from '../views/Parts.vue';
import Admin from '../views/Admin.vue';
import CCarForm from '../views/CCarForm.vue';
import DailyPrintView from '../views/DailyPrintView.vue';
import Login from '../views/Login.vue';
import Search from '../views/Search.vue';
import store from '../store/store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: { requiresAuth: true }
  },
  {
    path: '/search',
    name: 'search',
    component: Search,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/estimates',
    name: 'estimates',
    component: Estimates,
    meta: { requiresAuth: true }
  },
  {
    path: '/customers',
    name: 'customers',
    component: Customers,
    meta: { requiresAuth: true }
  },
  {
    path: '/parts',
    name: 'parts',
    component: Parts,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin',
    name: 'admin',
    component: Admin,
    meta: { requiresAuth: true }
  },
  {
    path: '/estimate/:id',
    name: 'estimate',
    component: Estimate
  },
  {
    path: '/booking/car/:id',
    name: 'booking-car',
    component: CCarForm,
    meta: { requiresAuth: true }
  },
  {
    path: '/booking/day',
    name: 'booking-day',
    component: DailyPrintView
  },
  {
    path: '/booking/:id',
    name: 'booking',
    component: Booking
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.state.app.loggedIn) {
      next({
        path: "/login",
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  }
  next();
});

export default router
